import { render, staticRenderFns } from "./TestTemplateTable.vue?vue&type=template&id=55955dac&scoped=true"
import script from "./TestTemplateTable.vue?vue&type=script&lang=js"
export * from "./TestTemplateTable.vue?vue&type=script&lang=js"
import style0 from "./TestTemplateTable.vue?vue&type=style&index=0&id=55955dac&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55955dac",
  null
  
)

export default component.exports